import styled from '@emotion/styled';

import NextIconSvg from '@/assets/icons/icon_next_gray.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Nav = styled.nav(() =>
  mq({
    backgroundColor: defaultTheme.background.secondary,
    padding: [
      `${defaultTheme.spacing.xxl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xxl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xxl} 40px`,
      `${defaultTheme.spacing.xxl} 0`,
    ],
  }),
);

export const OrderList = styled.ol(() =>
  mq({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: defaultTheme.spacing.s,
    flexWrap: 'wrap',
    width: ['100%', '100%', '100%', '1040px'],
    marginRight: 'auto',
    marginLeft: 'auto',
  }),
);

export const BreadcrumbItem = styled.li(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    color: defaultTheme.text.white,
    fontSize: defaultTheme.font.size.xs,
    '& > a': {
      ...hoverOpacity,
    },
  }),
);

export const NextIcon = styled.i(() =>
  mq({
    display: 'inline-block',
    width: '6px',
    height: '10.24px',
    backgroundImage: `url(${NextIconSvg})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
  }),
);
